import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { parseAgreementType, type AgreementTypeSearch } from '@/lib/agreement-type-search';
import { QUALIFIED_TYPES, type QualifiedType } from '@/features/customers-service-agreements/types';
import { CustomersPage } from '@/features/customers-service-agreements/customers-page';

/** The cars to sell agreements for. The list endpoint requires `vehicle:read`. */
export const Route = createFileRoute('/_app/service-agreement/customers')({
  staticData: { featureKey: 'customers-service-agreements' },
  validateSearch: (search: Record<string, unknown>): AgreementTypeSearch<QualifiedType> =>
    parseAgreementType(search, QUALIFIED_TYPES),
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'customers-service-agreements',
      permissions: ['vehicle:read'],
    }),
  component: Page,
});

const routeApi = getRouteApi('/_app/service-agreement/customers');

function Page() {
  // Keyed, so a sidebar link to another type lands on it rather than keeping the page's state.
  const { type } = routeApi.useSearch();
  return <CustomersPage key={type ?? 'default'} initialType={type} />;
}
